import { render, staticRenderFns } from "./QuestionGraphTab.vue?vue&type=template&id=79809c02"
import script from "./QuestionGraphTab.vue?vue&type=script&lang=ts"
export * from "./QuestionGraphTab.vue?vue&type=script&lang=ts"
import style0 from "./QuestionGraphTab.vue?vue&type=style&index=0&id=79809c02&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTabItem } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VRow,VTabItem})
